import React from 'react';

import { SvgIcon } from '@interlayer/js/app/components/common/SvgIcon';
import { Link } from '@interlayer/js/components/common/Link';

import { useInMobile } from '@interlayer/js/app/hooks/device/hooks/useMediaQuery';
import { useCurrentItemMenu } from '@interlayer/js/app/hooks/menu/useMenu';

import style from './BackButton.scss';

export const BackButton = ({ config: { link, title } = {} }: { config: { link?: string; title?: string } }) => {
    const isMobile = useInMobile();
    const { title: pageTitle } = useCurrentItemMenu();

    return (
        <Link
            className={style.link}
            {...link ? { href: link } : { onClick: () => window.history.back() }}
        >
            <SvgIcon
                width={isMobile ? '.8rem' : '1.1rem'}
                height={isMobile ? '.8rem' : '1.1rem'}
                type="arrow-left"
                className={style.icon}
            />

            {title || pageTitle}
        </Link>
    );
};

export default BackButton;

